import { useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { Navigation } from "@/components/Navigation";
import { Hero } from "@/components/Hero";
import { TrustBar } from "@/components/TrustBar";
import { Hierarchy } from "@/components/Hierarchy";
import { Capabilities } from "@/components/Capabilities";
import { Compliance } from "@/components/Compliance";
import { PlatformShowcase } from "@/components/PlatformShowcase";
import { Pricing } from "@/components/Pricing";
import { ContactForm } from "@/components/ContactForm";
import { Footer } from "@/components/Footer";

const Landing = () => {
  const contactRef = useRef(null);

  const scrollToContact = (interest = "general") => {
    contactRef.current?.focusForm(interest);
  };

  const scrollToPlatform = () => {
    document.getElementById("platform")?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div data-testid="landing-root">
      <Navigation onCtaClick={() => scrollToContact("general")} />
      <Hero onPrimary={() => scrollToContact("general")} onSecondary={scrollToPlatform} />
      <TrustBar />
      <Hierarchy />
      <Capabilities />
      <PlatformShowcase onCtaClick={() => scrollToContact("general")} />
      <Compliance />
      <Pricing onSelect={(interest) => scrollToContact(interest)} />
      <ContactForm ref={contactRef} />
      <Footer onCtaClick={() => scrollToContact("general")} />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#121A33",
            color: "#FFFFFF",
            border: "1px solid #2A3451",
            borderRadius: 0,
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
